import { useState, useEffect } from "react";
import {
  Autocomplete,
  TextField,
  Chip,
  FormLabel,
  Skeleton,
  Box,
  Tooltip,
  Typography,
} from "@mui/material";
import themeColorsDesingSystem from "assets/theme/ds-colors";
import MaskAndValid from "utils/maskAndValid";
import ListboxComponent from "./list-box-virtualized";

export default function StoreField({
  value,
  storeList,
  disabled,
  onChange,
  loading,
  required,
  allStore = true,
}) {
  const [selectedOptions, setSelectedOptions] = useState(value || []);

  useEffect(() => {
    setSelectedOptions(value || []);
  }, [value]);

  const storeNewList = (storeList || [])
    .filter((store) => store?.Id !== 0)
    .map((store) => ({
      Id: store?.Id,
      Nome: `${store?.Nome} | ${MaskAndValid.maskCNPJ(store?.CNPJ)}`,
      CNPJ: store?.CNPJ,
      Apelido:
        store?.Apelido !== " " || store?.Apelido?.length >= 2
          ? `${store?.Apelido} | ${MaskAndValid.maskCNPJ(store?.CNPJ)}`
          : `${store?.Nome} | ${MaskAndValid.maskCNPJ(store?.CNPJ)}`,
    }));

  if (storeNewList.length !== 1 && storeNewList.length !== 0 && allStore) {
    storeNewList.unshift({
      Id: "TODAS",
      Nome: "Todas",
      Apelido: "Todas",
    });
  }

  const handleChange = (event, newValue) => {
    let finalValue = newValue || [];

    if (newValue && newValue.some((option) => option.Id === "TODAS")) {
      finalValue = newValue.filter((option) => option.Id === "TODAS");
    }

    setSelectedOptions(finalValue);
    if (onChange) {
      onChange(finalValue);
    }
  };

  const removeOption = (optionId) => {
    const newOptions = selectedOptions.filter(
      (option) => option.Id !== optionId
    );
    setSelectedOptions(newOptions);
    if (onChange) {
      onChange(newOptions);
    }
  };

  const isOptionEqualToValue = (option, value) => {
    return option?.Id === value?.Id;
  };

  const getOptionLabel = (option) => {
    if (typeof option === "string") return option;
    return option?.Nome || "";
  };

  return (
    <Box>
      <FormLabel
        sx={{
          color: themeColorsDesingSystem.text.primary,
          fontSize: ".875rem",
          fontWeight: "600",
          lineHeight: 1.5,
          mb: 0,
          fontFamily: "Open Sans,sans-serif",
        }}
      >
        Lojas
        {required ? " *" : ""}
      </FormLabel>
      {loading ? (
        <Skeleton height="2.3em" sx={{ transform: "none" }} />
      ) : (
        <>
          <Autocomplete
            multiple
            options={storeNewList}
            value={selectedOptions}
            onChange={handleChange}
            disabled={disabled}
            isOptionEqualToValue={isOptionEqualToValue}
            getOptionLabel={getOptionLabel}
            ListboxComponent={ListboxComponent}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "&.Mui-focused fieldset": {
                      borderColor: themeColorsDesingSystem.primary.main,
                    },
                    "&.Mui-disabled": {
                      backgroundColor: themeColorsDesingSystem.stone.light,
                      cursor: "default",
                    },
                  },
                  "& .MuiInputBase-input": {
                    fontFamily: "Open Sans,sans-serif",
                    color: themeColorsDesingSystem.text.primary,
                    fontSize: ".875rem",
                    padding: "0 4px 0 5px!important",
                  },
                  "& .MuiIconButton-root": {
                    padding: 0,
                  },
                  "& .MuiAutocomplete-root": {
                    marginBottom: "0px",
                  },
                }}
              />
            )}
            renderTags={() => null}
            sx={{ mb: 1 }}
            renderOption={(props, option) => (
              <li {...props}>
                <Tooltip
                  arrow
                  title={getOptionLabel(option)}
                  leaveTouchDelay={100}
                  disableInteractive
                >
                  <Typography
                    noWrap
                    sx={{
                      fontFamily: "Open Sans,sans-serif",
                      color: themeColorsDesingSystem.text.primary,
                      fontSize: ".875rem",
                    }}
                  >
                    {getOptionLabel(option)}
                  </Typography>
                </Tooltip>
              </li>
            )}
          />

          {selectedOptions.length > 0 && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                overflowX: "auto",
                gap: 0.5,
                pb: 0.5,
                mb: 1,
                "&::-webkit-scrollbar": {
                  height: "6px",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#e0e0e0",
                  borderRadius: "4px",
                },
              }}
            >
              {selectedOptions.map((option) => (
                <Chip
                  key={option.Id}
                  label={option.Nome}
                  onDelete={() => removeOption(option.Id)}
                  sx={{
                    backgroundColor: "#f5f5f5",
                    color: themeColorsDesingSystem.text.primary,
                    "& .MuiChip-deleteIcon": {
                      color: "#666",
                    },
                    mr: 0.5,
                  }}
                />
              ))}
            </Box>
          )}
        </>
      )}
    </Box>
  );
}
